import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={9} fill="none" {...props}>
    <path stroke="#FE5000" strokeWidth={2} d="M1 4.333 3.77 7 10 1" />
  </svg>
);
export default SvgCheck;
